'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var useDefaultInternalState = require('../../hooks/useDefaultInternalState.js');
var NumberInput = require('./NumberInput.js');
var constants = require('../../constants.js');

var CurrencyInput = react.forwardRef(function (_a, ref) {
    var _b = _a.value, value = _b === void 0 ? '' : _b, setValue = _a.setValue, locale = _a.locale, _c = _a.currency, currency = _c === void 0 ? constants.DEFAULT_CURRENCY_FORMAT.CURRENCY : _c, _d = _a.decimals, decimals = _d === void 0 ? constants.DEFAULT_CURRENCY_FORMAT.DECIMALS : _d, onFocus = _a.onFocus, onBlur = _a.onBlur, _e = _a.currencyDisplay, currencyDisplay = _e === void 0 ? constants.DEFAULT_CURRENCY_FORMAT.DISPLAY_SYMBOL : _e, otherProps = tslib.__rest(_a, ["value", "setValue", "locale", "currency", "decimals", "onFocus", "onBlur", "currencyDisplay"]);
    var _f = useDefaultInternalState.default(value, setValue), valueState = _f[0], setValueState = _f[1];
    var _g = react.useState(false), isFocused = _g[0], setIsFocused = _g[1];
    var handleFocus = function (e) {
        setIsFocused(true);
        if (onFocus) {
            onFocus(e);
        }
    };
    var handleBlur = function (e) {
        setIsFocused(false);
        if (onBlur) {
            onBlur(e);
        }
    };
    var format = react.useMemo(function () {
        var formattedLocale = locale ? locale.replace('_', '-') : undefined;
        var formatter;
        try {
            var options = {
                style: 'currency',
                currency: currency,
                currencyDisplay: currencyDisplay,
                minimumFractionDigits: decimals,
                maximumFractionDigits: decimals
            };
            formatter = new Intl.NumberFormat(formattedLocale, options);
        }
        catch (_a) {
            formatter = new Intl.NumberFormat(formattedLocale, {
                minimumFractionDigits: decimals,
                maximumFractionDigits: decimals
            });
        }
        return function (value) {
            return value === '' ? value : formatter.format(value);
        };
    }, [locale, currency, decimals]);
    /**
     * Remove the given type to avoid to be overwrite
     */
    otherProps.type; var inputProps = tslib.__rest(otherProps, ["type"]);
    return (jsxRuntime.jsx(NumberInput.default, tslib.__assign({ ref: ref, type: isFocused ? 'number' : 'text', value: isFocused ? valueState : format(valueState), setValue: setValueState, withDecimals: decimals > 0, onFocus: handleFocus, onBlur: handleBlur }, inputProps)));
});
CurrencyInput.displayName = 'CurrencyInput';
var CurrencyInput$1 = CurrencyInput;

exports.default = CurrencyInput$1;
//# sourceMappingURL=CurrencyInput.js.map
